import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

// Tab the organization detail should open on next mount, set by shortcuts
// that land on the organization from elsewhere (a location's integration
// "go to template", say). Consumed and cleared by PMSOrganizationDetail; null
// means the default tab.
export const PMSOrganizationTabStore = GenericFieldFactory(
    "PMS_ORGANIZATION_TAB",
);
